var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PSection',{attrs:{"pubg-reward-match-section-23s1":""}},[_c('div',{staticClass:"inner-holder"},[_c('PubgRewardGroup',{attrs:{"id":"basic-rewards"}}),_c('PubgMatchGroup',{attrs:{"id":"match-rules"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }